import React from "react";
import "./Edu.css";
import { Container } from "react-bootstrap";
import { FaGraduationCap, FaSchool, FaBook } from "react-icons/fa";

const Edu = () => {
  const items = [
    {
      year: "2024",
      title: "B-Tech : Computer Science",
      content: "Session: 2020–2024, Rajasthan Technical University, Kota",
      icon: <FaGraduationCap />,
    },
    {
      year: "2020",
      title: "Higher Secondary School",
      content: "Class 12 (2019–2020), RBSE Board",
      icon: <FaSchool />,
    },
    {
      year: "2018",
      title: "Secondary School",
      content: "Class 10 (2017–2018), RBSE Board",
      icon: <FaBook />,
    },
  ];

  return (
    <div className="edu-wrapper">
      <Container>
        <h2 className="edu-heading">
          Education <span className="text-highlight">Timeline</span>
        </h2>
        <p className="edu-subheading">Where and what I studied</p>

        <div className="timeline-container">
          <div className="timeline-line"></div>

          {items.map((item, index) => (
            <div
              key={index}
              className={`timeline-point ${index % 2 === 0 ? "top" : "bottom"}`}
            >
              <div className="timeline-dot">{item.icon}</div>
              <div className="timeline-year">{item.year}</div>

              <div className="timeline-card">
                <h4>{item.title}</h4>
                <p>{item.content}</p>
              </div>
            </div>
          ))}
        </div>
      </Container>
    </div>
  );
};

export default Edu;
